module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "fmtitle"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Maps")])]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_Chapter01#pg3map1"
    }
  }, [_vm._v("Organisation of the Kriegsmarine, Spring 1940")])]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#pg32map1"
    }
  }, [_vm._v("Trade routes to Germany")])]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_Chapter03#pg47map1"
    }
  }, [_vm._v("The Winter War, 1939–1940")])]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter06#pg110map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Group V, 7 April")])]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07#pg118map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1. R-Boat Flotilla, 7 and 8 April")])]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07#pg123map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Group V, 8 April")])]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter07#pg128map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Skagerrak, 8 April")])]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#pg136map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Weserübung")])])]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_Chapter08#pg159map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("German mines in the Skagerrak, April 1940")])]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter10#pg175map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oslofjord, Group V")])]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_Chapter10#pg184map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Outer Oslofjord, Night of 8–9 April")])]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#pg191map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Drøbak Narrows, 9 April – Morning")])]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_Chapter11#pg196map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Oscarsborg Fortress")])]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_Chapter12#pg247map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Drøbak Narrows, 9 April – Afternoon")])]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter13#pg257map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Horten, 9 April")])]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_Chapter13#pg270map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Rauøy, 9 April")])]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg307map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("German advances out of Oslo")])]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg310map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Operation "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Weserübung Süd")]), _vm._v(" – Denmark 9 April")])]), _vm._v(" "), _c('p', {
    staticClass: "map"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_Chapter14#pg316map1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("British Submarines in the Skagerrak and Kattegat, April 1940")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a6e396c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Maps.vue
// module id = 78
// module chunks = 0